import './App.css';
import About from './components/About';
import Footer from './components/Footer';
import Header from './components/Header';
import NavBar from './components/NavBar';
import Servcies from './components/Services';

function App() {
  return (
    <main>
      <Header/>
      <NavBar/>
      <About/>
      <Servcies/>
      <Footer/>
    </main>
  );
}

export default App;
